import { z } from 'zod'

import { type ICompanyLiteData } from './company'

const roleTypesSchema = z.enum([
  'admin',
  'data-entry',
  'haulier',
  'haulier-manager',
  'partner',
  'shipper',
  'shipper-manager',
  'super-admin',
])
export interface IAvatar {
  id: number
  name: string
  url: string
}

export interface IBasicDataUser {
  avatar: IAvatar
  created_at: string
  email: string
  id: number
  last_name: string
  locale: string
  name: string
  phone: string
  pid: string
}

export interface IBasicUser {
  avatar?: {
    id: number
    name: string
    url: string
  }
  company?: ICompanyLiteData
  created_at: string
  email: string
  id: number
  last_name?: string
  locale: string
  name: string
  phone?: string
  pid: string
  role: IUserRole
  roles: IUserRole[]
  status: IUserStatus
  updated_at?: string
}

export type IGroupTypes = 'none' | 'notification' | 'transport'

export interface IRoleOption {
  label: string
  value: IRoleTypes
}
export type IRoleTypes = z.infer<typeof roleTypesSchema>

export interface IUserExists extends IBasicUser {
  exists: boolean
}

export interface IUserRole {
  id: 2
  name: IRoleTypes
}

export interface IUserStatus {
  alias: number
  title: string
}

export const newUserSchema = z.object({
  company_id: z.number().optional(),
  email: z.string().email(),
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  name: z.string(),
  phone: z.string().optional(), //todo refine it
  role: roleTypesSchema,
  source: z.string(),
})

export interface IAccessibility {
  method: string
  times: IAccessibilityTime[]
}

export interface IAccessibility {
  method: string
  times: IAccessibilityTime[]
}

export interface IAccessibilityTime {
  day: number
  time: string
}

export interface IAccessibilityTime {
  day: number
  time: string
}

export interface IAuth {
  email: string
  password: string
}

export interface IAuth {
  email: string
  password: string
}

export interface IAuthResponse {
  access_token: string
  expires_in?: number
  token_type?: string
}

export interface IAuthResponse {
  access_token: string
  expires_in?: number
  token_type?: string
}

export interface IChangePassword {
  confirmPassword: string
  password: string
}

export interface ICompanyAddress {
  address: string
  city: string
  country: {
    code: string
  }
  postcode: string
}

export interface IEditUser {
  company_id?: number
  email: string
  firstName?: string
  id: number
  phone?: null | string | undefined
  role?: IUserRole
}

export interface IEditUserResponse {
  email: string
  id: number
  last_name: string
  locale: string
  name: string
  password: string
  phone: string
}

export type INewUser = z.infer<typeof newUserSchema>

export interface IPosition {
  id: number
  title: string
}

export interface IPosition {
  id: number
  title: string
}

export interface IRegisterUserData {
  email?: string
  id?: string
  last_name?: string
  locale?: string
  name?: string
  password?: string
  phone?: string
}

export interface IUserContact {
  accessibilities: IAccessibility[]
  email: string
  hx: string
  id: number
  member_id: number
  method: string
  name: string
  nickname: string
  notes: string
  phone: string
  position: IPosition
  style: string
  timocom_id: string
  trans_id: string
  type?: string
  whatsapp: string
}
export interface IUserContact {
  accessibilities: IAccessibility[]
  email: string
  hx: string
  id: number
  member_id: number
  method: string
  name: string
  nickname: string
  notes: string
  phone: string
  position: IPosition
  style: string
  timocom_id: string
  trans_id: string
  type?: string
  whatsapp: string
}

export interface IUserContactData {
  data: IUserContact[]
}

export interface IUserContactData {
  data: IUserContact[]
}

export interface IUserContactForm {
  email?: string
  name?: string
  phone?: string
  type?: string
}

export interface IUserStatus {
  alias: number
  title: string
}
